import once from 'lodash/once';
import PrimitiveEE from '../PrimitiveEE';



const stream = PrimitiveEE();

let lastHash = window.location.hash;

const ping = () => {
  const hash = window.location.hash;

  if (hash !== lastHash) {
    stream.emit({ to: hash, from: lastHash });
    lastHash = hash;
  }

  setTimeout(ping, 100);
};

const bind = once(ping);

export default (callback) => {
  bind();

  return stream.on(callback);
};



// WEBPACK FOOTER //
// ./src/lib/dom/on-hashchange.js